import AUPPSRModifyForm from 'modules/new-applications/components/application-actions/PPSRRegister/PPSRModifyForm/AUPPSRModifyForm';
import NZPPSRModifyForm from 'modules/new-applications/components/application-actions/PPSRRegister/PPSRModifyForm/NZPPSRModifyForm';

export { AUPPSRModifyForm };
export { NZPPSRModifyForm };
